export const safeGetPortalId = () => {
  var _window;
  return window && ((_window = window) === null || _window === void 0 || (_window = _window.hubspot) === null || _window === void 0 || (_window = _window.portal) === null || _window === void 0 || (_window = _window.id) === null || _window === void 0 ? void 0 : _window.toString()) || null;
};